import React, { Suspense, useEffect } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import LoadingSpinner from "./component/Error";
import AOS from "aos";

// Import CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "aos/dist/aos.css";
import "./assets/css/icofont.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/nascent.css";
import "./assets/js/main.js";

// Create a wrapper component to initialize AOS
const AppWrapper = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <React.StrictMode>
      <Suspense fallback={<LoadingSpinner />}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </Suspense>
    </React.StrictMode>
  );
};

const rootElement = document.getElementById("root");

// Handle both client and server rendering
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <AppWrapper />);
} else {
  createRoot(rootElement).render(<AppWrapper />);
}
